module.exports = __webpack_public_path__ + "static/media/invoice.f8bd73a9.pdf";